
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/cart",
      function () {
        return require("private-next-pages/[locale]/cart/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/cart"])
      });
    }
  